<template>
  <div
    class="sticky-action-bar flex justify-between items-center relative text-white"
    :class="{ 'sticky-action-bar--hidden': hideBar }"
  >
    <div class="sticky-action-bar__image hidden md:block">
      <img
        v-lazy="image"
        :alt="`${product.title}-thumbnail-image`"
        width="88"
        height="96"
      >
    </div>

    <div class="sticky-action-bar__text hidden md:block">
      <h2 class="sticky-action-bar__title hidden md:block h3">
        {{ product.title }}
      </h2>
      <ul class="sticky-action-bar__info flex font-semibold">
        <li v-if="flavourCollectionTitle">
          {{ flavourCollectionTitle }}
        </li>
        <li v-if="productHasSubscriptionOption">
          {{ selectedSellingPlan ? 'Subscribe &amp; save' : 'One time purchase' }}
        </li>
      </ul>
    </div>

    <div class="sticky-action-bar__actions flex items-center">
      <button
        v-scroll-to="{ el: 'body' }"
        class="sticky-action-bar__scroll"
      >
        Edit choices
        <span>
          <ArrowRight />
        </span>
      </button>

      <ProductAddActions />
    </div>
  </div>
</template>

<script>
import ProductAddActions from './product-add-actions'
import { useProductStore } from '../../pinia/ProductStore'
import { mapState } from 'pinia'
import { getSizedImageUrl } from '@shopify/theme-images'

import ArrowRight from '../../icons/arrow-right-large'

export default {
  components: {
    ProductAddActions,
    ArrowRight
  },
  data() {
    return {
      hideBar: true,
      flavourCollections: [...window.theme.flavourCollections]
    }
  },
  computed: {
    ...mapState (useProductStore, [
      'product',
      'flavourCollectionHandle',
      'productHasSubscriptionOption',
      'selectedSellingPlan'
    ]),
    image () {
      let image = this.product.images?.[0]
      if (this.product.images.length > 1) {
        if (this.product.images?.[0]?.includes('.jpg') && this.product.images?.[1]?.includes('.png')) {
          image = this.product.images[1]
        }
      }
      return getSizedImageUrl(image, '190x')
    },
    flavourCollectionTitle () {
      if (this.flavourCollectionHandle) {
        const collection = this.flavourCollections?.find(collection => collection.handle === this.flavourCollectionHandle)
        const product = collection?.products?.find(product => product.handle === this.product.handle)
        return product?.title
      }
      return null
    }
  },
  mounted() {
    this.scrollListener()
  },
  methods: {
    scrollListener () {
      const nextSection = document.querySelector('section.product + section')
      const footer = document.querySelector('.shopify-section-group-footer-group')

      document.addEventListener('scroll', () => {
        const bottomOfProductSection = window.pageYOffset + nextSection.getBoundingClientRect().top - window.innerHeight
        const topOfFooter = window.pageYOffset + footer.getBoundingClientRect().top - window.innerHeight

        const scrolledPastTop = bottomOfProductSection < window.scrollY
        const aboveFooter = topOfFooter > window.scrollY

        this.hideBar = !(scrolledPastTop && aboveFooter)
      })
    },
  }
}
</script>
